// Course Editor
export const ADD_COURSE = "ADD_COURSE"
export const SET_ACTIVE_COURSE = "SET_ACTIVE_COURSE"
export const REMOVE_ACTIVE_COURSE = "REMOVE_ACTIVE_COURSE"
